import './video.css';

import Vimeo from '@vimeo/player';

export const video = Backbone.View.extend({
  el: $('#mainContainer'),
  container: $('.banner').length ? $('.banner') : $('body'),
  fitContainer: false,
  isFirstVimeo: true,

  initialize: function (options) {
    if (typeof options !== 'undefined' && typeof options.container !== 'undefined') {
      this.container = options.container;
      this.fitContainer = options.fitContainer;
    }

    this.initVideoComponent();
  },

  initVideoComponent: function ($videoContainer = this.container, fitContainer = this.fitContainer) {
    const canShowVideoUniversally = $('.sck-videoContainer, .sck_immersive').length > 0 || $('.tplSEO-videoContainer').length > 0;
    const hasToDisplayVideo = $('.js-videoComponentContainer').length && ((!DEVICE.isMobile && !DEVICE.isTablet) || canShowVideoUniversally);

    if (hasToDisplayVideo) {
      $($videoContainer).find('.js-video').each((index, element) => {
        const idUnique = Math.random().toString(36).substring(2);
        const iframeId = 'iframeVideo' + idUnique;

        let srcVideo = $(element).data('src'),
          loop = '',
          muted = '',
          autoplay = '',
          playButtonClass = srcVideo.indexOf('autoplay=1') > 0 ? ' u-Hidden--forced' : '',
          pauseButtonClass = srcVideo.indexOf('autoplay=1') > 0 ? '' : ' u-Hidden--forced',
          mutedClass = srcVideo.indexOf('muted=1') > 0 ? '' : ' u-Hidden--forced',
          soundOnClass = srcVideo.indexOf('muted=1') > 0 ? ' u-Hidden--forced' : '',
          deviceVideOClass = DEVICE.isMobile ? '--mobile' : DEVICE.isTablet ? '--tablet' : '--desktop',
          videoContainerWidth = $videoContainer.width(),
          videoContainerHeight = $videoContainer.height(),
          videoContainerPaddingBottom = videoContainerHeight / videoContainerWidth * 100,
          videoControls = canShowVideoUniversally ? 'controls' : '';

        const videoType = $(element).data('type'),
          urlWithParameters = srcVideo.indexOf('?') > 0;

        if (videoType === 'VIDEO' && urlWithParameters) {
          loop = srcVideo.indexOf('loop=1') > 0 ? ' loop="true"' : '';
          muted = srcVideo.indexOf('muted=1') > 0 ? ' muted="true"' : '';
          autoplay = srcVideo.indexOf('autoplay=1') > 0 ? ' autoplay' : '';
          srcVideo = srcVideo.split('?')[0];
        } else {
          srcVideo += urlWithParameters ? '&' : '?';
        }

        let autoplayFromCms = $(element).data('autoplay') === 1 ? 'allow=autoplay' : '';
        let htmlVideo = '';
        switch (videoType) {
          case 'VIMEO':
            if (canShowVideoUniversally) {
              srcVideo += 'autoplay=0&api=1&controls=true&autopause=0';
              htmlVideo = `
                <iframe id="${iframeId}" width="770" height="340" src="${srcVideo}" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen ${autoplayFromCms}></iframe>`;
              htmlVideo += `
                <i class="video-buttons play-button icon icon-play${playButtonClass}"></i>
                <i class="video-buttons pause-button icon icon-pause${pauseButtonClass}"></i>
                <i class="video-buttons mute-button icon icon-mute${mutedClass}"></i>
                <i class="video-buttons soundOn-button icon icon-soundOn${soundOnClass}"></i>`;
            } else {
              if (srcVideo.indexOf('autoplay=1') > 0 || srcVideo.indexOf('background=1') > 0) {
                srcVideo = srcVideo + 'controls=0';
              }
              htmlVideo = `
                <iframe width="1920" height="480" id="${iframeId}" src="${srcVideo}" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen allow=autoplay></iframe>`;
            }

            if (this.isFirstVimeo) {
              htmlVideo += '<script src="https://player.vimeo.com/api/player.js"></script>';
              this.isFirstVimeo = false;
            }

            break;
          case 'YOUTUBE':
            srcVideo += 'enablejsapi=1&background=1&cc_load_policy=0&controls=1&disablekb=1&fs=0&iv_load_policy=3&modestbranding=1&showinfo=0';
            htmlVideo = `
              <script src="https://www.youtube.com/iframe_api"></script>
              <iframe width="${videoContainerWidth}px" height="${videoContainerHeight}px" id="${iframeId}${deviceVideOClass}" class="js-video-youtube" src="${srcVideo}" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen allow=autoplay></iframe>`;
            break;
          default:
            htmlVideo = `
              <video width="${videoContainerWidth}px" height="${videoContainerHeight}px" id="headband-video${deviceVideOClass}" class="js-videomp4 headband-video" ${autoplay}${muted}${loop} controlslist="nodownload" ${videoControls} disablePictureInPicture>
                <source srcset="${srcVideo}" type="video/mp4">
              </video>`;
            break;
        }

        $(element).append(htmlVideo);

        if (videoType === 'VIDEO') {
          const video = $('#headband-video' + deviceVideOClass).get(0);

          video.muted = $(element).data('src').indexOf('muted=1') > 0;
          $(element).data('src').indexOf('autoplay=1') > 0 ? video.play() : video.pause();

          $(element).find('.play-button').on('click', function () {
            video.play();
            $(element).find('.play-button').addClass('u-Hidden--forced');
            $(element).find('.pause-button').removeClass('u-Hidden--forced');
          });

          $(element).find('.pause-button').on('click', function () {
            video.pause();
            $(element).find('.play-button').removeClass('u-Hidden--forced');
            $(element).find('.pause-button').addClass('u-Hidden--forced');
          });

          $(element).find('.mute-button').on('click', function () {
            video.muted = false;
            $(element).find('.mute-button').addClass('u-Hidden--forced');
            $(element).find('.soundOn-button').removeClass('u-Hidden--forced');
          });

          $(element).find('.soundOn-button').on('click', function () {
            video.muted = true;
            $(element).find('.soundOn-button').addClass('u-Hidden--forced');
            $(element).find('.mute-button').removeClass('u-Hidden--forced');
          });
        } else if (videoType === 'YOUTUBE') {
          let player;

          window.onYouTubeIframeAPIReady = function () {
            player = new YT.Player(iframeId + deviceVideOClass, {
              events: {
                'onReady': onPlayerReady,
                'onStateChange': onPlayerStateChange
              }
            });
          };

          window.onPlayerReady = function (event) {
            srcVideo.indexOf('autoplay=1') > 0 ? event.target.playVideo() : '';
            srcVideo.indexOf('muted=1') > 0 ? event.target.setVolume(0) : event.target.setVolume(10);

            $(element).find('.play-button').on('click', function () {
              event.target.playVideo();
              $(element).find('.play-button').addClass('u-Hidden--forced');
              $(element).find('.pause-button').removeClass('u-Hidden--forced');
            });

            $(element).find('.pause-button').on('click', function () {
              event.target.stopVideo();
              $(element).find('.play-button').removeClass('u-Hidden--forced');
              $(element).find('.pause-button').addClass('u-Hidden--forced');
            });

            $(element).find('.mute-button').on('click', function () {
              event.target.setVolume(10);
              $(element).find('.soundOn-button').removeClass('u-Hidden--forced');
              $(element).find('.mute-button').addClass('u-Hidden--forced');
            });

            $(element).find('.soundOn-button').on('click', function () {
              event.target.setVolume(0);
              $(element).find('.mute-button').removeClass('u-Hidden--forced');
              $(element).find('.soundOn-button').addClass('u-Hidden--forced');
            });
          };

          window.onPlayerStateChange = function (event) {
            if (event.data === YT.PlayerState.PLAYING) {
              $(element).find('.play-button').addClass('u-Hidden--forced');
              $(element).find('.pause-button').removeClass('u-Hidden--forced');
            } else if (event.data === YT.PlayerState.PAUSED) {
              $(element).find('.play-button').removeClass('u-Hidden--forced');
              $(element).find('.pause-button').addClass('u-Hidden--forced');
            }
          };
        } else if (videoType === 'VIMEO') {
          let src = $(element).data('src').split('?')[0],
            options = {
              src: src,
              width: videoContainerWidth,
              height: videoContainerHeight,
              playsinline: false,
              controls: true
            };
          let player = new Vimeo(iframeId, options);

          const $videoVisible = $('.js-videoComponentContainer:visible');

          if (fitContainer) {
            $videoVisible.find('iframe').css({'opacity': 0, 'background': 'none'});
          }

          player.ready().then(() => {
            videoContainerWidth = $videoVisible.width();
            videoContainerHeight = $videoVisible.height();
            player.on('play', () => {
              $(element).find('.play-button').addClass('u-Hidden--forced');
              $(element).find('.pause-button').removeClass('u-Hidden--forced');

              if (fitContainer) {
                // Set default iframe size to container, to get video ratio
                $videoVisible.find('iframe').css({
                  width: '100%',
                  height: 'auto'
                });
                player.getVideoWidth().then((width) => {
                  player.getVideoHeight().then((height) => {
                    const aspectRatio = width / height;
                    const datas = {
                      containerHeight: videoContainerHeight,
                      containerWidth: videoContainerWidth,
                      videoWidth: videoContainerWidth,
                      videoHeight: videoContainerWidth / aspectRatio
                    };
                    const fittingDim = this.getFittingDimensions(datas);
                    $videoVisible.find('iframe').css({
                      width: fittingDim.width,
                      height: fittingDim.height,
                      opacity: 1,
                      background: '#000'
                    });
                  });
                });
              }
            });

            player.on('pause', function () {
              $(element).find('.pause-button').addClass('u-Hidden--forced');
              $(element).find('.play-button').removeClass('u-Hidden--forced');
            });

            $(element).find('.play-button').off('click').on('click', function () {
              player.play();
              $(element).find('.play-button').addClass('u-Hidden--forced');
              $(element).find('.pause-button').removeClass('u-Hidden--forced');
            });

            $(element).find('.pause-button').off('click').on('click', function () {
              player.pause();
              $(element).find('.play-button').removeClass('u-Hidden--forced');
              $(element).find('.pause-button').addClass('u-Hidden--forced');
            });

            $(element).find('.mute-button').off('click').on('click', function () {
              player.setVolume(1);
              $(element).find('.mute-button').addClass('u-Hidden--forced');
              $(element).find('.soundOn-button').removeClass('u-Hidden--forced');
            });

            $(element).find('.soundOn-button').on('click', function () {
              player.setVolume(0);
              $(element).find('.mute-button').removeClass('u-Hidden--forced');
              $(element).find('.soundOn-button').addClass('u-Hidden--forced');
            });
          });
        }

        videoType === 'YOUTUBE' || videoType === 'VIMEO' ? $(element).closest('.js-videoBannerContainer').css('padding-bottom', videoContainerPaddingBottom + '%') : '';

        dispatcher.trigger('lazyload:update');
      });
    }
  },

  // Return fitting dimensions percent to make video cover container
  getFittingDimensions: function (datas) {
    let fittingWidthPercent = '100%';
    let fittingHeightPercent = '100%';

    if (datas.videoHeight < datas.containerHeight) {
      const videoCurrentHeight = (datas.videoWidth * datas.containerHeight) / datas.videoHeight;

      fittingWidthPercent = ((100 * videoCurrentHeight) / datas.containerWidth + 1) + '%';
    } else if (datas.videoHeight > datas.containerHeight) {
      const videoCurrentWidth = (datas.videoHeight * datas.containerWidth) / datas.videoWidth;

      fittingHeightPercent = ((100 * videoCurrentWidth) / datas.containerHeight + 1) + '%';
    }

    return {
      width: fittingWidthPercent, height: fittingHeightPercent
    };
  }
});